const onKeyDown = (event, onExpand)=>{
    if (!onExpand) {
        return;
    }
    switch(event.key){
        case 'ArrowLeft':
            onExpand(false);
            break;
        case 'ArrowRight':
            onExpand(true);
            break;
    }
};

export { onKeyDown };
//# sourceMappingURL=expand-on-keydown.js.map
